<div class="form-errors">
  @for (error of errorMessages; track $index) {
    <div class="form-error">
      <div class="form-error-text">{{ error }}</div>
    </div>
  }
</div>
